<template>
  <!--
    Use ComponentResolver to allow applications to provide an
    implementation of ApplicationWorkspace that overrides the standard one
  -->
  <Maintenance v-if="applicationMaintenance" />
  <ComponentResolverMobile
    v-else
    component-id="AppWorkspace"
    :override-component-id="overrideComponentId"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import Maintenance from '@/agilis/components/Maintenance/Maintenance.vue'
import Configuration from '@/agilis/util/Configuration'

export default {
  name: 'ApplicationView',

  components: {
    Maintenance
  },

  computed: {
    ...mapGetters({
      'applicationMaintenance': 'contextStore/applicationMaintenance',
      'applicationId': 'contextStore/applicationId',
      'workspaceId': 'contextStore/workspaceId'
    }),

    overrideComponentId () {
      const workspace = Configuration.auth.findWorkspace(this.applicationId, this.workspaceId)
      return workspace?.componentId
    }
  }
}
</script>
<style lang="scss" src="../scss/global.scss">

</style>
